export class ProductStage {
    constructor(public stepName: string, public stepValue: string, public count: number) { }
}
